// Generated by ReScript, PLEASE EDIT WITH CARE

import Dompurify from "dompurify";

function sanitize(s) {
  return Dompurify.sanitize(s);
}

export {
  sanitize ,
}
/* dompurify Not a pure module */
